import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import { MatchCardEventOneTeam } from './MatchCardEventOneTeam';
import { MatchCardEventTwoTeams } from './MatchCardEventTwoTeams';

/**
 * @const {Number} - How many seconds ago does an event happen to be display an animation
 */
const EVENT_CUTOFF = 60;

function between( goalTime, latestTime ) {
    let below = latestTime.periodSeconds - EVENT_CUTOFF;

    if ( goalTime > below ) {
        return true;
    }

    return false;
}

/*
    checks when the next period will start then stops the end of quarter event from firing 5 mins before the start of the next quarter.
*/
function timeChecker( period ) {
    const timeNow = Date.now();
    const nextPeriod = Date.parse( period.nextPeriodStart );
    const lastAnimationTime = nextPeriod - 300000;
    if ( timeNow > lastAnimationTime ) {
        return false;
    }

    return true;
}

export const MatchCardEvent = ( { matchInfo } ) => {
    const [ event, setEvent ] = useState( [] );
    const [ goal, setGoal ] = useState( [] );
    const [ periodTrigger, setPeriodTrigger ] = useState( '' );

    const matchId = matchInfo?.match?.matchId ? matchInfo.match.matchId : matchInfo.providerId;
    const wormData = useSelector( state => window.PULSE.app.redux.selectors.match.scoreWorm( state, matchId ) );
    const matchTime = useSelector( state => window.PULSE.app.redux.selectors.match.matchClock( state, matchId ) );
    const matchInfoStatus = useSelector( state => window.PULSE.app.redux.selectors.match.isActuallyLive( state, matchId ) );

    if ( wormData ) {
        if ( wormData.scoringEvents.length != goal.length ) {
            setGoal( wormData.scoringEvents );
        }
    }

    /*
        Adds the latest goal to the event array, once a new goal event has been added to the goal state via the scoreWorm.
    */
    useEffect( () => {
        if ( matchTime && goal.length > 0 ) {
            let latestGoal = goal[ goal.length - 1 ];
            let latestTime = matchTime.periods[ 0 ];
            if ( between( latestGoal.periodSeconds, latestTime ) && latestTime.periodNumber == latestGoal.periodNumber ) {
                setEvent( prevState => [ ...prevState, {latestGoal, shown: false} ] );
            }
        }
    }, [ goal ] );

    /*
        Adds the latest quarter to the events array when a period has started or ended.
    */
    useEffect( () => {
        if ( matchTime && periodTrigger !== '' ) {
            let latestTime = matchTime.periods[ 0 ];
            setEvent( prevState => [ ...prevState, {latestTime, shown: false} ] );
        }
    }, [ periodTrigger ] );

    if ( matchTime ) {
        let latestTime = matchTime.periods[ 0 ];
        // stops animations from happening if the game isn't live
        if ( !matchInfoStatus ) {
            return ( null );
        }
        if ( latestTime.periodCompleted && timeChecker( latestTime ) && periodTrigger !== 'end' ) {
            setPeriodTrigger( 'end' );
        } else if ( latestTime.periodSeconds < ( EVENT_CUTOFF + 1 ) && periodTrigger !== 'start' ) {
            setPeriodTrigger( 'start' );
        }
    }

    function handleRemove( e ) {
        let array = event;
        const index = array.indexOf( e );
        if ( index !== -1 ) {
            array.splice( index, 1 );
            setEvent( array );
        }
    }

    return (
        <>
            { event.map( ( item, index ) => (
                <ErrorBoundary key={ index } fallback={ <></> }>
                    { item.latestGoal ? (
                        <MatchCardEventOneTeam
                            key={ index }
                            event={ item }
                            removeEvent={ handleRemove }
                        />
                    ) : (
                        <MatchCardEventTwoTeams
                            key={ index }
                            event={ item }
                            match={ matchInfo }
                            removeEvent={handleRemove}
                        />
                    ) }
                </ErrorBoundary>
            ) ) }
        </>
    );
};